import { PlanMainService } from './../service/plan-main.service';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy
} from '@angular/core';
import { PlanService } from './../../services/plan.service';
import { ResultlistZaiko } from '../../models/plan/zaikoItems';
import { Subject } from 'rxjs';
export interface Zaikoshiire {
  renban: number;
  memo: string;
}

@Component({
  selector: 'app-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.css']
})
export class DetailModalComponent implements OnInit, OnDestroy {
  @Input() data: ResultlistZaiko;
  @Output('close') close: any = new EventEmitter<any>();
  soubi: any[] = [];
  soubiList: any[] = [];
  valuedata: ResultlistZaiko = {};
  zaikoshiirelist: Zaikoshiire[] = [];
  public ngUnsubscribe = new Subject();
  constructor(
    private planService: PlanService,
    private _planservicemain: PlanMainService
  ) { }

  ngOnInit() {
    if (this.data) {
      this.valuedata = this.data;
      if (this.valuedata.shoudanDate1 == '19000101') {
        this.valuedata.shoudanDate1 = '';
      }
      if (this.valuedata.shoudanDate2 == '19000101') {
        this.valuedata.shoudanDate2 = '';
      }
      if (this.valuedata.shoudanDate3 == '19000101') {
        this.valuedata.shoudanDate3 = '';
      }
      if (this.valuedata.carDimension == '･･') {
        this.valuedata.carDimension = '';
      }
      this._planservicemain
        .getzaikoShiireMemoList(this.valuedata.zaikoCd)
        .takeUntil(this.ngUnsubscribe)
        .subscribe((data: Zaikoshiire[]) => {
          this.zaikoshiirelist = [];
          if (data) {
            this.zaikoshiirelist = data;
          }
        });
      this.planService.getSoubiData().takeUntil(this.ngUnsubscribe).subscribe(data => {
        if (data) {
          this.soubiList = data;
          this.valuedata.equipment.filter((val, i) => {
            this.soubiList.filter((value, j) => {
              if (i == j && val == 1) {
                this.soubi.push(value);
              }
            });
          });
        }
      });
    }
  }
  onClose() {
    this.close.emit();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/detail-modal/detail-modal.component.ts